<template>
  <div class="discipline">
    <c-modal-summary
      :active="isShowSummaryModal"
      :type="summaryTypeLocal"
      :title="summaryModalTitleLocal"
      :items="summaryModalItemsLocal"
      @close="isShowSummaryModal = false"
    />

    <div v-if="isDisabledFilters && tableData.records.length === 0 && !isDataLoading" class="discipline-empty">
      Штрафов, нарушений, поощрений пока нет
    </div>

    <div
      v-if="(tableData.records.length !== 0 && !isDataLoading) || (!isDataLoading && !isDisabledFilters)"
      class="discipline-filters"
    >
      <div class="discipline-filters-fields">
        <c-input
          v-model="filialLocal"
          class="discipline-filters-fields-filial"
          :items="filialLocalItems"
          type="select"
          :searchable="true"
          :clearable="true"
          label="Филиал"
          placeholder="Все"
        />
        <c-input
          v-model="measureLocal"
          class="discipline-filters-fields-measure"
          :items="measureLocalItems"
          type="select"
          label="Мера"
          :multiple="true"
          placeholder="Все"
        />
        <c-input
          ref="disciplineFilterPeriod"
          v-model="periodLocal"
          class="discipline-filters-fields-period"
          label="За период"
          placeholder="00.00.0000 - 00.00.0000"
          type="period"
          icon="calendar"
          :clearable="true"
          :icon-right="true"
        />
      </div>
      <div class="discipline-filters-buttons">
        <c-button class="discipline-filters-buttons-apply" label="Применить" color="primary" @click="applyFilters" />
        <c-button class="discipline-filters-buttons-reset" label="Сбросить" @click="resetFilters" />
      </div>
    </div>
    <div
      v-if="(tableData.records.length !== 0 && !isDataLoading) || (!isDataLoading && !isDisabledFilters)"
      class="discipline-summary"
    >
      <div
        class="discipline-summary-item discipline-summary-item-red"
        @click="openSummaryModal('fines', summaryData.fines.items)"
      >
        <div class="discipline-summary-item-title">Штрафы</div>
        <div class="discipline-summary-item-count">
          <div class="discipline-summary-item-count-text">
            {{ summaryData.fines.totalCount }}
          </div>
        </div>
        <div class="discipline-summary-item-summ">{{ formatAmount(summaryData.fines.totalSum) }} <span>฿</span></div>
      </div>
      <div
        class="discipline-summary-item discipline-summary-item-red"
        @click="openSummaryModal('fouls', summaryData.fouls.items)"
      >
        <div class="discipline-summary-item-title">Нарушения</div>
        <div class="discipline-summary-item-count">
          <div class="discipline-summary-item-count-text">
            {{ summaryData.fouls.totalCount }}
          </div>
        </div>
        <div class="discipline-summary-item-summ">{{ formatAmount(summaryData.fouls.totalSum) }} <span>б.</span></div>
      </div>
      <div
        class="discipline-summary-item discipline-summary-item-green"
        @click="openSummaryModal('bonuses', summaryData.bonuses.items)"
      >
        <div class="discipline-summary-item-title">Поощрения</div>
        <div class="discipline-summary-item-count">
          <div class="discipline-summary-item-count-text">
            {{ summaryData.bonuses.totalCount }}
          </div>
        </div>
        <div class="discipline-summary-item-summ">{{ formatAmount(summaryData.bonuses.totalSum) }} <span>฿</span></div>
      </div>
    </div>
    <div
      v-if="(tableData.records.length !== 0 && !isDataLoading) || (!isDataLoading && !isDisabledFilters)"
      class="discipline-table"
    >
      <c-data-table-personal-employee
        ref="table"
        class="discipline-table-table"
        :levels="1"
        empty-records-label="Штрафов, нарушений, поощрений пока нет"
        :disabled-columns="[]"
        :sorted-column="tableData.sortedColumn"
        :data="tableData"
        @sortedEvent="refreshTable"
      />
    </div>
    <c-loader
      v-if="isDataLoading"
      class="discipline-loader"
      label="Данные загружаются"
      :active="isDataLoading"
      height="500"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";
import DataTablePersonalEmployee from "@/pages/personal-employee/additions/data-table-personal-employee";
import DisciplineSummaryModal from "@/pages/personal-employee/additions/modals/discipline-summary-modal";
import Loader from "@/components/loader";

import { FineReasonDescription } from "@/entities/models/fine-reason";
import { ViolationTypeDescription } from "@/entities/models/violation-type";

export default {
  name: "personal-employee-discipline",

  components: {
    "c-button": Button,
    "c-input": Input,
    "c-loader": Loader,
    "c-data-table-personal-employee": DataTablePersonalEmployee,
    "c-modal-summary": DisciplineSummaryModal,
  },

  data() {
    return {
      isDataLoading: false,
      isDisabledScrollDataLoading: false,
      isDisabledFilters: true,
      filialLocalItems: [],
      filialLocal: null,
      measureLocalItems: [
        { label: "Штрафы", value: "fines" },
        { label: "Поощрения", value: "bonuses" },
        { label: "Нарушения", value: "fouls" },
      ],
      measureLocal: [],
      periodStart: this.$route.query.periodStart ? this.$route.query.periodStart : "",
      periodEnd: this.$route.query.periodEnd ? this.$route.query.periodEnd : "",
      periodLocal: "",
      isShowSummaryModal: false,
      summaryTypeLocal: "",
      summaryModalTitleLocal: "",

      dictionaries: {
        fineDescriptions: {},
        violationDescriptions: {},
      },

      summaryData: {
        fines: {
          totalCount: 0,
          totalSum: 0,
          items: [],
        },
        fouls: {
          totalCount: 0,
          totalSum: 0,
          items: [],
        },
        bonuses: {
          totalCount: 0,
          totalSum: 0,
          items: [],
        },
      },
      summaryModalItemsLocal: [],
      page: 1,
      tableData: {
        type: "discipline",
        columns: [],
        records: [],
        actions: false,
        enabledFields: [],
        levels: 1,
        filteredColumns: [],
        activeFilteredColumns: [],
        globalFilters: [],
        sortedColumn: {
          sortBy: this.$route.query.sortBy ? this.$route.query.sortBy : "date_timestamp",
          sortType: this.$route.query.sortType ? this.$route.query.sortType : "desc",
        },
      },
    };
  },
  computed: {
    ...mapGetters("personalEmployee", ["getTableColumnsDiscipline"]),
    ...mapGetters("referenceReasonsForFines", ["getFinesCollection"]),
    ...mapGetters("referenceViolationTypes", ["getViolationsCollection"]),
  },

  watch: {
    getFinesCollection(fines) {
      const dict = {};
      fines.forEach((fine) => {
        dict[fine.id] = FineReasonDescription(fine);
      });
      this.dictionaries.fineDescriptions = dict;
    },
    getViolationsCollection(types) {
      const dict = {};
      types.forEach((type) => {
        dict[type.id] = ViolationTypeDescription(type);
      });
      this.dictionaries.violationDescriptions = dict;
    },
  },

  mounted() {
    document.querySelector(".layout").addEventListener("scroll", this.loadMoreRecords);
  },

  async created() {
    this.isDataLoading = true;

    await Promise.all([
      this.$store.dispatch("referenceReasonsForFines/getFinesCollection"),
      this.$store.dispatch("referenceViolationTypes/getViolationsCollection"),
    ]);

    await this.$store.dispatch("employees/getReferenceValues", "filial").then((res) => {
      this.filialLocalItems = res.data.map((item) => ({ id: item.id, value: item.id, label: item.name }));

      if (this.$route.query.filial) {
        const c = this.filialLocalItems.findIndex(
          (filial) => filial.value.toString() === this.$route.query.filial.toString(),
        );
        if (c !== -1) this.filialLocal = this.filialLocalItems[c];
      }

      if (this.$route.query.measure) {
        this.$route.query.measure.split(",").forEach((item) => {
          const c = this.measureLocalItems.findIndex((measure) => item === measure.value);
          if (c !== -1) this.measureLocal.push(this.measureLocalItems[c]);
        });
      }

      this.tableData.columns = this.getTableColumnsDiscipline.map((column) => {
        column.isSorted = column.id === this.tableData.sortedColumn.sortBy;
        return column;
      });

      this.getDisciplineData();
    });
  },

  methods: {
    setPeriod() {
      if (this.periodStart.length > 0 && this.periodEnd.length > 0) {
        this.$refs.disciplineFilterPeriod.period.start.input = this.periodStart;
        this.$refs.disciplineFilterPeriod.period.end.input = this.periodEnd;

        const period = `${this.periodStart}-${this.periodEnd}`;
        const today = moment().startOf("day").format("DD.MM.YYYY").toString();
        const yesterday = moment().startOf("day").subtract(1, "day").format("DD.MM.YYYY").toString();
        const firstDayCurrentWeek = moment().startOf("day").startOf("week").format("DD.MM.YYYY").toString();
        const lastDayCurrentWeek = moment().startOf("day").format("DD.MM.YYYY").toString();
        const firstDayLastWeek = moment()
          .startOf("day")
          .startOf("week")
          .subtract(1, "week")
          .format("DD.MM.YYYY")
          .toString();
        const lastDayLastWeek = moment()
          .startOf("day")
          .endOf("week")
          .subtract(1, "week")
          .format("DD.MM.YYYY")
          .toString();
        const sevenDayAgo = moment().startOf("day").subtract(6, "day").format("DD.MM.YYYY").toString();
        const firstDayCurrentMonth = moment().startOf("day").startOf("month").format("DD.MM.YYYY").toString();
        const firstDayLastMonth = moment()
          .startOf("day")
          .subtract(1, "month")
          .startOf("month")
          .format("DD.MM.YYYY")
          .toString();
        const lastDayLastMonth = moment()
          .startOf("day")
          .subtract(1, "month")
          .endOf("month")
          .format("DD.MM.YYYY")
          .toString();

        if (today === this.periodStart && today === this.periodEnd) {
          this.$refs.disciplineFilterPeriod.dateValue = "Сегодня";
        } else if (yesterday === this.periodStart && yesterday === this.periodEnd) {
          this.$refs.disciplineFilterPeriod.dateValue = "Вчера";
        } else if (firstDayCurrentWeek === this.periodStart && lastDayCurrentWeek === this.periodEnd) {
          this.$refs.disciplineFilterPeriod.dateValue = "С начала недели";
        } else if (firstDayLastWeek === this.periodStart && lastDayLastWeek === this.periodEnd) {
          this.$refs.disciplineFilterPeriod.dateValue = "Прошлая неделя";
        } else if (today === this.periodEnd && sevenDayAgo === this.periodStart) {
          this.$refs.disciplineFilterPeriod.dateValue = "Последние 7 дней";
        } else if (firstDayCurrentMonth === this.periodStart && today === this.periodEnd) {
          this.$refs.disciplineFilterPeriod.dateValue = "Текущий месяц";
        } else if (firstDayLastMonth === this.periodStart && lastDayLastMonth === this.periodEnd) {
          this.$refs.disciplineFilterPeriod.dateValue = "Прошлый месяц";
        } else if (
          this.periodStart === moment().startOf("day").subtract(1, "month").format("DD.MM.YYYY").toString() &&
          today === this.periodEnd
        ) {
          this.$refs.disciplineFilterPeriod.dateValue = "Последний месяц";
        } else {
          this.$refs.disciplineFilterPeriod.dateValue = period;
        }
      }
    },

    getDisciplineData() {
      const workerId = this.$route.params.id;

      if (
        this.periodStart.length === 0 &&
        this.periodEnd.length === 0 &&
        this.filialLocal === null &&
        this.measureLocal.length === 0
      ) {
        this.isDisabledFilters = true;
      } else {
        this.isDisabledFilters = false;
      }

      this.$store
        .dispatch("personalEmployee/getInfoDisciplineForWorker", {
          workerId,
          sortBy: this.tableData.sortedColumn.sortBy,
          sortType: this.tableData.sortedColumn.sortType,
          page: this.page,
          periodStart: this.periodStart,
          periodEnd: this.periodEnd,
          filialId: this.filialLocal !== null ? this.filialLocal.value : undefined,
          disciplineType:
            this.measureLocal.length > 0 ? this.measureLocal.map((item) => item.value).join(",") : undefined,
        })
        .then((res) => {
          const data = res.response;

          this.summaryData.bonuses.totalCount = data.summary.bonuses.total_count;
          this.summaryData.bonuses.totalSum = data.summary.bonuses.total_sum;
          this.summaryData.fouls.totalCount = data.summary.fouls.total_count;
          this.summaryData.fouls.totalSum = data.summary.fouls.total_sum;
          this.summaryData.fines.totalCount = data.summary.fines.total_count;
          this.summaryData.fines.totalSum = data.summary.fines.total_sum;

          if (data.summary.bonuses.summary) {
            this.summaryData.bonuses.items = [...data.summary.bonuses.summary];
          }
          if (data.summary.fouls.summary) {
            this.summaryData.fouls.items = [...data.summary.fouls.summary];
          }
          if (data.summary.fines.summary) {
            this.summaryData.fines.items = [...data.summary.fines.summary];
          }

          const mapRecords = data.list.map((record) => ({
            foul_id: record.foul_id,
            ubp_id: record.ubp_id,
            id: {
              value: record.id,
            },
            filial: {
              value: record.filial,
            },
            date_timestamp: {
              value: record.date,
            },
            is: {
              value: record.is,
            },
            reason: {
              value: record.reason,
              descriptionModel: (() => {
                if (record.is === "Штраф") {
                  return this.dictionaries.fineDescriptions[record.id];
                }
                if (record.is === "Нарушение") {
                  return this.dictionaries.violationDescriptions[record.id];
                }
                return null;
              })(),
            },
            summ: {
              value: record.summ,
            },
            user: {
              value: record.user,
            },
            deadline_timestamp: {
              value: record.deadline,
            },
            explanatory: {
              value: record.explanatory,
            },
            explanatoryWriteAccess: data.explanatory_writing_access,
            isFined: record.is_fined,
            isShowRow: true,
          }));

          if (this.page === 1) {
            this.isDisabledScrollDataLoading = false;
            this.tableData.records = [];
            this.tableData.records = [...mapRecords];
          } else {
            this.tableData.records = this.tableData.records.concat(mapRecords);

            if (mapRecords.length === 0) this.isDisabledScrollDataLoading = true;
          }

          const queryFilters = {
            ...(this.periodStart === "" ? null : { periodStart: this.periodStart }),
            ...(this.periodEnd === "" ? null : { periodEnd: this.periodEnd }),
            ...(this.filialLocal === null ? null : { filial: this.filialLocal.value }),
            ...(this.measureLocal.length === 0
              ? null
              : { measure: this.measureLocal.map((item) => item.value).join(",") }),
            sortBy: this.tableData.sortedColumn.sortBy,
            sortType: this.tableData.sortedColumn.sortType,
          };

          this.$router
            .replace({
              name: "personal-employee-discipline",
              query: {
                ...queryFilters,
              },
            })
            .catch(() => {});

          setTimeout(() => {
            this.isDataLoading = false;
          }, 300);

          setTimeout(() => {
            this.setPeriod();
          }, 500);
        });
    },

    refreshTable(e) {
      this.tableData.sortedColumn.sortType = e.sortType;
      this.tableData.sortedColumn.sortBy = e.sortBy;
      this.isDataLoading = true;
      this.page = 1;
      this.getDisciplineData();
    },

    formatAmount(x) {
      if (!x) {
        return "";
      }

      if (!Number.isInteger(x)) {
        return x
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },

    resetFilters() {
      this.isDataLoading = true;
      this.filialLocal = null;
      this.measureLocal = [];
      this.$refs.disciplineFilterPeriod.periodReset();
      this.periodStart = "";
      this.periodEnd = "";
      this.getDisciplineData();
    },

    applyFilters() {
      this.isDataLoading = true;
      this.page = 1;
      const periodStart = this.$refs.disciplineFilterPeriod.period.start.input;
      const periodEnd = this.$refs.disciplineFilterPeriod.period.end.input;
      this.periodStart = periodStart;
      this.periodEnd = periodEnd;
      this.getDisciplineData();
    },

    openSummaryModal(type, items) {
      if (items.length > 0) {
        switch (type) {
          case "fines":
            this.summaryModalTitleLocal = "Штрафы";
            this.summaryModalItemsLocal = [...this.summaryData.fines.items];
            break;
          case "fouls":
            this.summaryModalTitleLocal = "Нарушения";
            this.summaryModalItemsLocal = [...this.summaryData.fouls.items];
            break;
          case "bonuses":
            this.summaryModalTitleLocal = "Поощрения";
            this.summaryModalItemsLocal = [...this.summaryData.bonuses.items];
            break;
          default:
            this.summaryModalTitleLocal = "";
        }
        this.summaryTypeLocal = type;
        this.isShowSummaryModal = true;
      }
    },

    loadMoreRecords() {
      if (this.$route.name !== "personal-employee-discipline") {
        return false;
      }

      const layout = document.querySelector(".layout");
      const isScrollable = layout.scrollHeight > layout.clientHeight;

      const scroll = Math.round(layout.scrollTop);
      const height = layout.scrollHeight - layout.clientHeight;

      if (isScrollable && scroll === height && !this.isDataLoading && !this.isDisabledScrollDataLoading) {
        this.isLoadingData = true;
        this.page += 1;
        this.getDisciplineData();
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
.discipline {
  &-empty {
    margin-top: 44px;
    font-size: 13px;
    line-height: 100%;
    text-align: center;
    color: #8e9cbb;

    @media screen and (max-width: 700px) {
      margin-top: 37px;
    }
  }

  &-filters {
    margin-top: 44px;
    width: 100%;
    display: flex;

    @media screen and (max-width: 1200px) {
      flex-direction: column;
    }

    &-fields {
      max-width: 700px;
      width: 100%;
      display: flex;

      @media screen and (max-width: 700px) {
        flex-direction: column;
      }

      &-filial {
        max-width: 168px;
        width: 100%;
        flex-grow: 1;

        @media screen and (max-width: 700px) {
          max-width: 100%;
        }
      }

      &-measure {
        margin-left: 30px;
        max-width: 267px;
        width: 100%;
        flex-grow: 1;

        @media screen and (max-width: 700px) {
          max-width: 100%;
          margin: 27px 0 0 0;
        }
      }

      &-period {
        margin-left: 31px;

        ::v-deep & .c-input-container_period {
          @media screen and (max-width: 1200px) {
            left: -130px;
          }
          @media screen and (max-width: 800px) {
            left: -140px;
          }
          @media screen and (max-width: 767px) {
            left: 0;
          }
        }

        @media screen and (max-width: 700px) {
          max-width: 100%;
          margin: 25px 0 0 0;
        }
      }
    }

    &-buttons {
      margin-left: 37px;
      display: flex;
      align-self: flex-end;

      @media screen and (max-width: 1200px) {
        margin: 24px 0 0 0;
        align-self: flex-start;
      }

      @media screen and (max-width: 700px) {
        width: 100%;
      }

      &-apply {
        @media screen and (max-width: 700px) {
          width: calc(50% - 8px);
        }
      }

      &-reset {
        margin-left: 10px;

        @media screen and (max-width: 700px) {
          width: calc(50% - 8px);
        }
      }
    }
  }

  &-summary {
    margin-top: 24px;
    max-width: 1160px;
    width: 100%;
    display: flex;

    @media screen and (max-width: 767px) {
      flex-direction: column;
    }

    &-item {
      display: flex;
      border: 1px solid #dfe4ef;
      height: 50px;
      max-width: 33.3%;
      width: 100%;
      align-items: center;
      padding: 0 20px;
      cursor: pointer;

      @media screen and (max-width: 767px) {
        height: 40px;
        max-width: calc(100% + 60px);
        width: calc(100% + 60px);
        margin-left: -30px;
        border-left: 0;
        border-right: 0;
      }

      @media screen and (max-width: 700px) {
        max-width: calc(100% + 40px);
        width: calc(100% + 40px);
        margin-left: -20px;
      }

      &:nth-child(2),
      &:nth-child(3) {
        margin-left: 10px;

        @media screen and (max-width: 767px) {
          margin-left: -30px;
          border-top: none;
        }

        @media screen and (max-width: 700px) {
          margin-left: -20px;
        }
      }

      &-red {
        & .discipline-summary-item-title {
          color: #ff238d;
        }

        & .discipline-summary-item-count .discipline-summary-item-count-text {
          color: #ff238d;
        }
      }

      &-green {
        & .discipline-summary-item-title {
          color: #12c971;
        }

        & .discipline-summary-item-count .discipline-summary-item-count-text {
          color: #12c971;
        }
      }

      &-title {
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;
      }

      &-count {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 5px;
        width: 28px;
        height: 20px;
        background: #f5f7fa;
        border-radius: 30px;

        &-text {
          font-weight: bold;
          font-size: 12px;
          line-height: 130%;
          text-align: center;
        }
      }

      &-summ {
        margin-left: auto;
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;

        & span {
          font-size: 14px;
        }
      }
    }
  }

  &-table {
    margin-top: 24px;

    @media screen and (max-width: 700px) {
      margin-top: 0;
    }

    &-table {
      max-width: 1160px;
      width: 100%;

      ::v-deep .c-table__column-label {
        white-space: nowrap;

        @media screen and (max-width: 700px) {
          white-space: normal;
        }
      }

      ::v-deep .c-table__cell {
        //white-space: nowrap;
      }

      @media screen and (max-width: 700px) {
        width: calc(100% + 40px);
      }
    }
  }

  &-loader {
    margin-top: 24px;
    max-width: 1160px;

    @media screen and (max-width: 700px) {
      ::v-deep & .loader-overlay {
        width: calc(100% + 40px);
        left: -20px;
        border-right: none;
        border-left: none;
      }
    }
  }
}
</style>
